import { render, staticRenderFns } from "./ResultsTraffic.vue?vue&type=template&id=067b0362&"
import script from "./ResultsTraffic.vue?vue&type=script&lang=js&"
export * from "./ResultsTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports